export const COLORS_DATA: string[] = [
  '#000000FF',
  '#ffffffFF',
  '#404040FF',
  '#C3CFD9FF',
  '#788896FF',
  '#4B5C6BFF',
  '#2C88D9FF',
  '#6558F5FF',
  '#730FC3FF',
  '#BD34D1FF',
  '#1AAE9FFF',
  '#207868FF',
  '#897A5FFF',
  '#AC6363FF',
  '#E91E62FF',
  '#E8833AFF',
  '#F7C325FF',
  '#065CDEFF',
  // 'none'
];
